var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main" }, [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "table mb-24" },
      [
        _c(
          "el-row",
          [
            _c("el-col", { attrs: { span: 3 } }, [_vm._v("法定代表人")]),
            _c("el-col", { attrs: { span: 5 } }, [
              _vm._v(_vm._s(_vm.info.legalPersonName || "--")),
            ]),
            _c("el-col", { attrs: { span: 3 } }, [_vm._v("经营状态")]),
            _c("el-col", { attrs: { span: 5 } }, [
              _vm._v(_vm._s(_vm.info.regStatus || "--")),
            ]),
            _c("el-col", { attrs: { span: 3 } }, [_vm._v("成立日期")]),
            _c("el-col", { attrs: { span: 5 } }, [
              _vm.info.estiblishTime
                ? _c("span", [
                    _vm._v(_vm._s(_vm.info.estiblishTime.slice(0, 10))),
                  ])
                : _c("span", [_vm._v("--")]),
            ]),
          ],
          1
        ),
        _c(
          "el-row",
          [
            _c("el-col", { attrs: { span: 3 } }, [_vm._v("注册资本")]),
            _c("el-col", { attrs: { span: 5 } }, [
              _vm._v(_vm._s(_vm.info.regCapital || "--")),
            ]),
            _c("el-col", { attrs: { span: 3 } }, [_vm._v("实缴资本")]),
            _c("el-col", { attrs: { span: 5 } }, [
              _vm._v(_vm._s(_vm.info.actualCapital || "--")),
            ]),
            _c("el-col", { attrs: { span: 3 } }, [_vm._v("核准日期")]),
            _c("el-col", { attrs: { span: 5 } }, [
              _vm.info.approvedTime
                ? _c("span", [
                    _vm._v(_vm._s(_vm.info.approvedTime.slice(0, 10))),
                  ])
                : _c("span", [_vm._v("--")]),
            ]),
          ],
          1
        ),
        _c(
          "el-row",
          [
            _c("el-col", { attrs: { span: 3 } }, [_vm._v("统一社会信用代码")]),
            _c("el-col", { attrs: { span: 5 } }, [
              _vm._v(_vm._s(_vm.info.creditCode || "--")),
            ]),
            _c("el-col", { attrs: { span: 3 } }, [_vm._v("组织机构代码")]),
            _c("el-col", { attrs: { span: 5 } }, [
              _vm._v(_vm._s(_vm.info.orgNumber || "--")),
            ]),
            _c("el-col", { attrs: { span: 3 } }, [_vm._v("工商注册号")]),
            _c("el-col", { attrs: { span: 5 } }, [
              _vm._v(_vm._s(_vm.info.regNumber || "--")),
            ]),
          ],
          1
        ),
        _c(
          "el-row",
          [
            _c("el-col", { attrs: { span: 3 } }, [_vm._v("纳税人识别号")]),
            _c("el-col", { attrs: { span: 5 } }, [
              _vm._v(_vm._s(_vm.info.taxNumber || "--")),
            ]),
            _c("el-col", { attrs: { span: 3 } }, [_vm._v("企业类型")]),
            _c("el-col", { attrs: { span: 5 } }, [
              _vm._v(_vm._s(_vm.info.companyOrgType || "--")),
            ]),
            _c("el-col", { attrs: { span: 3 } }, [_vm._v("营业期限")]),
            _c("el-col", { attrs: { span: 5 } }, [
              _vm.info.estiblishTime
                ? _c("span", { staticClass: "mr-5" }, [
                    _vm._v(
                      _vm._s(_vm.info.estiblishTime.slice(0, 10)) + " 至 "
                    ),
                  ])
                : _vm._e(),
              _vm.info.toTime
                ? _c("span", [_vm._v(_vm._s(_vm.info.toTime.slice(0, 10)))])
                : _c("span", [_vm._v("无固定期限")]),
            ]),
          ],
          1
        ),
        _c(
          "el-row",
          [
            _c("el-col", { attrs: { span: 3 } }, [_vm._v("登记机关")]),
            _c("el-col", { attrs: { span: 5 } }, [
              _vm._v(_vm._s(_vm.info.regInstitute || "--")),
            ]),
            _c("el-col", { attrs: { span: 3 } }, [_vm._v("人员规模")]),
            _c("el-col", { attrs: { span: 5 } }, [
              _vm._v(_vm._s(_vm.info.staffNumRange || "--")),
            ]),
            _c("el-col", { attrs: { span: 3 } }, [_vm._v("参保人数")]),
            _c("el-col", { attrs: { span: 5 } }, [
              _vm._v(_vm._s(_vm.info.socialStaffNum || "--")),
            ]),
          ],
          1
        ),
        _c(
          "el-row",
          [
            _c("el-col", { attrs: { span: 3 } }, [_vm._v("曾用名")]),
            _c("el-col", { attrs: { span: 5 } }, [
              _vm._v(_vm._s(_vm.info.historyNames || "--")),
            ]),
            _c("el-col", { attrs: { span: 3 } }, [_vm._v("英文名")]),
            _c("el-col", { attrs: { span: 5 } }, [
              _vm._v(_vm._s(_vm.info.property3 || "--")),
            ]),
            _c("el-col", { attrs: { span: 3 } }, [_vm._v("简称")]),
            _c("el-col", { attrs: { span: 5 } }, [
              _vm._v(_vm._s(_vm.info.alias || "--")),
            ]),
          ],
          1
        ),
        _c(
          "el-row",
          [
            _c("el-col", { attrs: { span: 3 } }, [_vm._v("所属地区")]),
            _c("el-col", { attrs: { span: 5 } }, [
              _vm._v(_vm._s(_vm.getBase(_vm.info.base))),
            ]),
            _c("el-col", { attrs: { span: 3 } }, [_vm._v("所属行业")]),
            _c("el-col", { attrs: { span: 13 } }, [
              _vm._v(_vm._s(_vm.info.industry || "--")),
            ]),
          ],
          1
        ),
        _c(
          "el-row",
          [
            _c("el-col", { attrs: { span: 3 } }, [_vm._v("企业地址")]),
            _c("el-col", { attrs: { span: 21 } }, [
              _vm._v(_vm._s(_vm.info.regLocation || "--")),
            ]),
          ],
          1
        ),
        _c(
          "el-row",
          [
            _c("el-col", { attrs: { span: 3 } }, [_vm._v("经营范围")]),
            _c("el-col", { attrs: { span: 21 } }, [
              _vm._v(_vm._s(_vm.info.businessScope || "--")),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _vm._m(1),
    _c(
      "div",
      { staticClass: "mb-24" },
      [
        _c(
          "el-table",
          {
            attrs: {
              data: _vm.shareholder.tableData,
              border: "",
              "header-cell-style": { background: "#EDF0F4", color: "#333" },
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                type: "index",
                label: "序号",
                align: "center",
                width: "50",
              },
            }),
            _c("el-table-column", {
              attrs: { label: "股东(发起人)", prop: "name", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_vm._v(_vm._s(scope.row.name || "--"))]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "出资比例", prop: "capital", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.capital && scope.row.capital.length > 0
                        ? _c("span", [
                            _vm._v(_vm._s(scope.row.capital[0].percent)),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "认缴出资额", prop: "capital", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.capital && scope.row.capital.length > 0
                        ? _c("span", [
                            _vm._v(_vm._s(scope.row.capital[0].amomon)),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "认缴出资日期",
                prop: "capital",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.capital && scope.row.capital.length > 0
                        ? _c("span", [
                            _vm._v(_vm._s(scope.row.capital[0].time || "--")),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "center" },
          [
            _c("pagination", {
              attrs: {
                pageNum: _vm.shareholder.pageNum,
                total: _vm.shareholder.total,
              },
              on: {
                currentChange: function (val) {
                  return _vm.handleCurrentChange(val, 1)
                },
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._m(2),
    _c(
      "div",
      { staticClass: "mb-24" },
      [
        _c(
          "el-table",
          {
            attrs: {
              data: _vm.personnel.tableData,
              border: "",
              "header-cell-style": { background: "#EDF0F4", color: "#333" },
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                type: "index",
                label: "序号",
                align: "center",
                width: "50",
              },
            }),
            _c("el-table-column", {
              attrs: { label: "姓名", prop: "name", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_vm._v(_vm._s(scope.row.name || "--"))]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "职位", prop: "typeJoin", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.typeJoin && scope.row.typeJoin.length > 0
                        ? _c("div", [
                            _vm._v(_vm._s(scope.row.typeJoin.join("，"))),
                          ])
                        : _c("div", [_vm._v("--")]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "center" },
          [
            _c("pagination", {
              attrs: {
                pageNum: _vm.personnel.pageNum,
                total: _vm.personnel.total,
              },
              on: {
                currentChange: function (val) {
                  return _vm.handleCurrentChange(val, 2)
                },
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._m(3),
    _c(
      "div",
      { staticClass: "mb-24" },
      [
        _c(
          "el-table",
          {
            attrs: {
              data: _vm.record.tableData,
              border: "",
              "header-cell-style": { background: "#EDF0F4", color: "#333" },
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                type: "index",
                label: "序号",
                align: "center",
                width: "50",
              },
            }),
            _c("el-table-column", {
              attrs: { label: "变更日期", prop: "changeTime", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_vm._v(_vm._s(scope.row.changeTime || "--"))]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "变更项目", prop: "changeItem", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_vm._v(_vm._s(scope.row.changeItem || "--"))]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "变更前",
                prop: "contentBefore",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.contentBefore
                        ? _c("div", {
                            staticClass: "div-html",
                            domProps: {
                              innerHTML: _vm._s(scope.row.contentBefore),
                            },
                          })
                        : _c("div", [_vm._v("--")]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "变更后", prop: "contentAfter", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.contentAfter
                        ? _c("div", {
                            staticClass: "div-html",
                            domProps: {
                              innerHTML: _vm._s(scope.row.contentAfter),
                            },
                          })
                        : _c("div", [_vm._v("--")]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "center" },
          [
            _c("pagination", {
              attrs: { total: _vm.record.total },
              on: {
                currentChange: function (val) {
                  return _vm.handleCurrentChange(val, 3)
                },
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [_c("p", [_vm._v("工商信息")])])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [_c("p", [_vm._v("企业股东")])])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [_c("p", [_vm._v("主要人员")])])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [_c("p", [_vm._v("变更记录")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }